import React, { Component, Fragment } from 'react';
import Page from 'shared/Page';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {bindActionCreators} from 'redux';
import { getConfirmationPageSettings, isKioskMode } from 'checkout/selectors/ui';
import ConfirmationContainer from './ConfirmationContainer';
import ConfirmationHeader from '../components/ConfirmationHeader';
import KioskTextSection from 'shared/KioskTextSection';
import KioskGoBackButton from 'shared/KioskGoBackButton';
import GoBackTimeout from 'shared/GoBackTimeout';
import SidekickTicketPrint from '../components/SidekickTicketPrint';
import KioskConfirmationContainer from "../../kiosk/containers/KioskConfirmationContainer"
import KioskLayoutContainer from '../../kiosk/containers/KioskLayoutContainer';
import KioskFooterContainer from '@v/kiosk/containers/KioskFooterContainer';

class ConfirmationPage extends Page {

    map = {
        ConfirmationContainer: ConfirmationContainer,
        ConfirmationHeader: ConfirmationHeader,
        KioskTextSection: KioskTextSection,
        KioskConfirmationContainer: KioskConfirmationContainer,
        KioskFooterContainer: KioskFooterContainer,
        KioskGoBackButton: KioskGoBackButton,
        GoBackTimeout: GoBackTimeout,
        SidekickTicketPrint: SidekickTicketPrint,
    };

    render() {

        if (this.props.isKioskMode) {
            return (
                <div className="kiosk__checkout">
                    <div className="kiosk__confirmation-page">
                        {this.getComponents()}
                    </div>
                </div>
            );
        }

        return <div className='confirmation-wrap'>
            <div className="confirmation">
                {this.getComponents()}
            </div>
        </div>
    }

}

const mapStateToProps = (state, props) => {
    return {
        settings: getConfirmationPageSettings(state),
        isKioskMode: isKioskMode(state),
    }
}

const mapDispatchToProps = dispatch => {
    return bindActionCreators({
    }, dispatch);
}

ConfirmationPage.propTypes = {
}

export default connect(mapStateToProps, mapDispatchToProps)(ConfirmationPage)
